import React from "react";
import { useHistory } from "react-router-dom";

import { Button } from "react-admin";

import { OutboundStatus, OutboundState } from "../../../utils/constants";
import {
  ArrivedAtIcon,
  PlacedAtIcon,
  ReleasedAtIcon,
} from "../../../components/common/iconography";
import { deepRedirect } from "../../../utils/utils";

export const AdvanceButton = ({ record, newStatus, buttonLabel, ...rest }) => {
  const history = useHistory();
  let isDisabled = false;
  let buttonIcon = <ArrivedAtIcon />;

  if (!record) return null;
  else if (newStatus === OutboundStatus.PLACED) {
    buttonIcon = <PlacedAtIcon />;
  } else if (newStatus === OutboundStatus.RELEASED) {
    debugger;
    buttonIcon = <ReleasedAtIcon />;
    isDisabled = record.state !== OutboundState.COMPLETED;
  }

  const handleClick = (event) => {
    event.stopPropagation();
    event.preventDefault();

    const prefillField =
      newStatus === OutboundStatus.ARRIVED
        ? "arrivalDateTime"
        : newStatus === OutboundStatus.PLACED
        ? "placementDateTime"
        : newStatus === OutboundStatus.RELEASED
        ? "departureDateTime"
        : null;
    const state = prefillField
      ? {
          outboundAdvancePrefill: {
            field: prefillField,
            value: new Date(),
          },
        }
      : undefined;
    deepRedirect(
      history,
      `/outboundShipments/${record.id}/dispatch`,
      undefined,
      state
    );
  };

  return (
    <Button
      label={buttonLabel}
      color="primary"
      onClick={handleClick}
      disabled={isDisabled}
    >
      {buttonIcon}
    </Button>
  );
};
